import React from "react";
import { Accordion, Container } from "react-bootstrap";
import "./assets/styles/_index.scss";
import useBurgerMenu from "../../hooks/useBurgerMenu";
const { CTALink } = require("@starberry/gatsby-theme-utils/Modules/CTALinkModule");

const BurgerMenu = () => {
  const { menu_data } = useBurgerMenu();
  return (
    <div className="burger-menu">
      <Container>
        <Accordion className="burger-menu-accordion">
          {menu_data?.length > 0 &&
            menu_data.map(({ node }, i) => (
              <div className="accordion-item parent-link">
                <CTALink link={node?.link} target_window={node?.link?.target_window}>
                  {node?.title}
                </CTALink>
              </div>
            ))}
        </Accordion>
      </Container>
    </div>
  );
};

export default BurgerMenu;
